import React, { ReactNode } from "react";

import { ListItemButton } from "@mui/material";
import { ListItemButtonProps } from "@mui/material/ListItemButton/ListItemButton";
import { styled } from "@mui/material/styles";

import { IgTypography } from "./IgTypography";
import { IgCustomTheme } from "./theme";

interface IgListItemButtonsProps extends ListItemButtonProps {
  label: string | ReactNode;
  igVariant?: "primary" | "success";
  direction?: "row" | "column";
  buttonFontWeight?: number;
}
export const IgListItemButton = ({
  label,
  igVariant,
  buttonFontWeight,
  direction,
  ...rest
}: IgListItemButtonsProps) => {
  const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
    // transition: "0.2s",
    borderRadius: "4px",
    justifyContent: "center",
    border: `1px solid ${(theme as IgCustomTheme).igBorders.core.default}`,
    "&:hover, &:focus": {
      border: `1px solid ${
        igVariant === "success"
          ? (theme as IgCustomTheme).igBorders.success.hover
          : (theme as IgCustomTheme).igBorders.core.hover
      }`,
    },
    "&:focus": {
      backgroundColor: "transparent",
    },
    "&.Mui-selected": {
      backgroundColor:
        igVariant === "success" ? "transparent !important" : "#E9F0FB",
      border: `1px solid ${
        igVariant === "success"
          ? (theme as IgCustomTheme).igBorders.success.active
          : (theme as IgCustomTheme).igBorders.accent.active
      }`,
    },
  }));

  return (
    <StyledListItemButton {...rest}>
      <IgTypography sx={{ fontWeight: buttonFontWeight ?? 600 }}>
        {label}
      </IgTypography>
    </StyledListItemButton>
  );
};
